import { Col, Row } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { editClientApi } from '../../../../../../config/Api'
import { AssignDietForm } from './components/AssignDietForm'
import { UnsentDietBanner } from './components/UnsentDietBanner'
import { PatientDetailForm } from './components/PatientDetailForm'
import './style/AssignDiet.scss'
export const AssignDiet = (props) => {
    const { id } = useParams();
    const [patientData, setPatientData] = useState();
    useEffect(() => {
        setPatientData(props?.patientData)
    }, [props?.patientData])

    return (
        <div className='AssignDiet'>
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}>
                <Col xs={24} md={24} xl={24} xxl={24} className="align-self-center">

                    <PatientDetailForm patientData={patientData} onChange={props.onChange}
                        tagData={props?.tagData}
                        setTagData={props?.setTagData}
                    />
                </Col>
                <Col xs={24} md={24} xl={24} xxl={24} className="align-self-center">
                    {/* saved diets the patient hasn't got yet */}
                    <UnsentDietBanner patientId={id} />
                    <AssignDietForm />
                </Col>
            </Row>
        </div >
    )
}
